import { render, staticRenderFns } from "./RegimeFederal.vue?vue&type=template&id=1488d35f&scoped=true"
import script from "./RegimeFederal.vue?vue&type=script&lang=js"
export * from "./RegimeFederal.vue?vue&type=script&lang=js"
import style0 from "./RegimeFederal.vue?vue&type=style&index=0&id=1488d35f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488d35f",
  null
  
)

export default component.exports